import FormValidator from '@/modules/form_validator';
import Zipcoder from '@/modules/zipcoder';

import { handleNotify } from '@/modules/helper';

export default class CreditCard {
  constructor(options) {
    this.form = options.form;
    this.isPagarme = document.documentElement.dataset.partnerName === 'pagarme';
    this.options = options;
    this.paymentMethodField = document.querySelector('[data-payment-method-field]');
    this.tokenTarget = document.querySelector('[data-credit-card-target="token"]');
  }

  // The `PagarmeCheckout.init` binds the form submission by itself
  bindPagarme() {
    PagarmeCheckout.init(
      (data) => {
        this.tokenTarget.value = data['pagarmetoken-0'];

        this.options.success(this.formValidator);

        return false; // Avoids form submission
      },
      (error) => this.onPagarmeError(error),
    );
  }

  createToken() {
    this.createPagarmeToken();
  }

  // this.form.submit() does not trigger the Pagarme form submission listener
  // so we need to create a temporary submit button to trigger the form submission like the original submit button
  createPagarmeToken() {
    const submitButton = document.createElement('input');

    submitButton.type = 'submit';
    submitButton.style.display = 'none';

    this.form.appendChild(submitButton);

    submitButton.click();
    submitButton.remove();
  }

  init() {
    if (!document.querySelector('[data-form]')) return;

    new Zipcoder({ scope: 'payment' }).create();

    this.formValidator = new FormValidator({ form: this.form, onValid: this.onValid.bind(this) }).create();

    if (this.isPagarme) this.bindPagarme();

    return this;
  }

  // When cart is free the payment method field is not shown
  isCreditCard() {
    return this.paymentMethodField?.value === 'credit_card';
  }

  onPagarmeError(json) {
    this.formValidator.resetState();

    const allErrors = [
      { id: 'global', message: json.errors['request.card.number'] },
      { id: 'global', message: json.errors['request.card.cvv'] },
      { id: 'global', message: json.errors['request.card.holder_name'] },
      { id: 'global', message: json.errors['request.card.exp_month'] },
      { id: 'global', message: json.errors['request.card.exp_year'] },
      { id: 'global', message: json.errors['request.card'] },
    ];

    const errors = allErrors.filter((item) => !!item.message);

    handleNotify({ errors });
  }

  onValid() {
    this.isCreditCard() ? this.createToken() : this.options.success(this.formValidator);
  }
}
